/* eslint-disable indent */ import { template as template_7b9eca92f11c4eac856911377f696465 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { task as trackedTask } from 'reactiveweb/ember-concurrency';
import moment from 'moment-timezone';
import FormatDurationAxisBi from 'eflex/util/bi-duration-axis-formatter';
import echartsTheme from 'eflex/echarts-theme';
import { waitFor } from '@ember/test-waiters';
import { clone } from 'ramda';
import BiNoDataPlaceholder from 'eflex/components/bi/no-data-placeholder';
import Spinner from 'eflex/components/spinner';
import { get } from '@ember/helper';
import EChart from 'eflex/components/e-chart';
export default class CycleTimeSerialNumber extends Component {
    @service
    queryRunner;
    @service
    intl;
    get params() {
        return {
            stationIds: this.args.stationIds,
            modelIds: this.args.modelIds,
            userIds: this.args.userIds,
            tags: this.args.tags,
            startDate: this.args.startDate,
            endDate: this.args.endDate,
            shiftNames: this.args.shiftNames
        };
    }
    getData = task({
        drop: true
    }, waitFor(async (params)=>{
        const serialCycleTimeQuery = await this.queryRunner.queryWithParams.perform(params, [
            {
                $sort: {
                    timestamp: 1
                }
            },
            {
                $project: {
                    serialNumber: 1,
                    cycleTime: 1,
                    timestamp: 1
                }
            }
        ]);
        const serialCycleTimeData = await this.queryRunner.runQuery.perform('BuildStatuses', serialCycleTimeQuery);
        return {
            chartData: this.getEchartOptions(serialCycleTimeData),
            exportData: ()=>this.formatCycleTimeExportData(clone(serialCycleTimeData))
        };
    }));
    serialCycleTimeData = trackedTask(this, this.getData, ()=>[
            this.params,
            this.args.refresher
        ]);
    getEchartOptions(cycleTimeData) {
        return {
            title: {
                text: this.intl.t('bi.chartLabel.cycleTimeBySerial')
            },
            tooltip: {
                trigger: 'axis',
                formatter: (params)=>{
                    const serialNumber = params[1].data.name;
                    const tooltipData = params[0];
                    return `<div style="text-align:center;">${serialNumber}</div><br>
            <div>${tooltipData.marker} ${tooltipData.name}:  <span style="font-weight:bold;">
            ${moment.duration(tooltipData.value, 'milliseconds').format('d[d] h[h] m[m] s[s]', {
                        precision: 1,
                        trim: 'both mid'
                    })}
            </span></div>`;
                }
            },
            legend: {
                show: false,
                selected: {
                    'series 1': true,
                    'series 2': false
                }
            },
            yAxis: [
                {
                    type: 'value',
                    min: 0,
                    axisLabel: {
                        formatter: (value)=>FormatDurationAxisBi(value)
                    }
                },
                {
                    type: 'value',
                    show: false
                }
            ],
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: cycleTimeData.map((data)=>moment(data.timestamp).format('MM/DD/YYYY hh:mm A')),
                axisLabel: {
                    show: true,
                    rotate: 75,
                    interval: 'auto'
                }
            },
            series: [
                {
                    yAxisIndex: 0,
                    name: this.intl.t('navigation.bi.cycleTime'),
                    data: cycleTimeData.map((m)=>m.cycleTime),
                    type: 'line',
                    color: echartsTheme.colorPalette.biBlue,
                    markLine: {
                        data: [
                            {
                                type: 'average',
                                name: 'Avg'
                            }
                        ],
                        label: {
                            show: true,
                            position: 'insideEndTop',
                            formatter: (params)=>`${this.intl.t('bi.chartLegend.avg')}: ${moment.duration(params.value, 'milliseconds').format('d[d] h[h] m[m] s[s]', {
                                    precision: 1,
                                    trim: 'both mid'
                                })}`
                        }
                    }
                },
                {
                    yAxisIndex: 1,
                    data: cycleTimeData.map((m)=>{
                        return {
                            name: m.serialNumber,
                            value: 0
                        };
                    }),
                    type: 'line',
                    color: '#00000000'
                }
            ]
        };
    }
    formatCycleTimeExportData(cycleTimeData) {
        cycleTimeData.forEach((serialNumber)=>{
            serialNumber.cycleTime = moment.duration(serialNumber.cycleTime, 'milliseconds').format('d[d] h[h] m[m] s[s]', {
                precision: 1,
                trim: 'both mid'
            });
            serialNumber.timestamp = moment(serialNumber.timestamp).format('MM/DD/YYYY hh:mm A');
            delete serialNumber._id;
        });
        return cycleTimeData;
    }
    static{
        template_7b9eca92f11c4eac856911377f696465(`
    <div ...attributes>
      {{#if this.serialCycleTimeData.isRunning}}
        <Spinner @belowSidePanel={{true}} />
      {{else if (get this.serialCycleTimeData.value.chartData.series '0.data.length')}}
        <div class="row h-100">
          <div class="col d-flex justify-content-between">
            <EChart
              @option={{this.serialCycleTimeData.value.chartData}}
              @exportData={{this.serialCycleTimeData.value.exportData}}
              class="h-100 w-100 cycle-time-serial-number"
            />
          </div>
        </div>
      {{else}}
        <BiNoDataPlaceholder />
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
